import { formatDateTime, formatRelativeTime } from "@/lib/i18n";
import { useApi } from "./use-api";

export interface ActivityItem {
  id: string;
  type: string;
  title: string;
  timestamp: string;
  displayTime: string;
  relativeTime: string;
}

export function useRecentActivity() {
  const { data, isLoading, error } = useApi<Omit<ActivityItem, "displayTime" | "relativeTime">[]>("/v1/dashboard/activity");

  return {
    data: (data ?? []).map((item) => ({
      ...item,
      displayTime: formatDateTime(item.timestamp),
      relativeTime: formatRelativeTime(item.timestamp),
    })),
    isLoading,
    error,
  };
}
